import {
  useState, useEffect,
} from 'react';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { ProfileUser } from 'lib/types/users';
import { Project } from 'lib/types/projects';
import { map } from 'bluebird';
import { PortfolioCard } from 'components/PortfolioCard';
import { Skeleton } from '@mui/material';

interface Props {
  profileUser: ProfileUser;
}

export const Portfolio = ({ profileUser }: Props) => {
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState<Project[]>([]);
  const API = useApi();
  const currentUser = useCurrentUser();

  useEffect(() => {
    const getProjects = async () => {
      setLoading(true);
      try {
        const featuredProjects = await API.getUsersFeaturedProjects(profileUser.id);

        const projectsWithStats = await map(featuredProjects, async (project) => {
          if (!project.posts?.length || !project.id) {
            return { ...project, stats: undefined };
          }
          try {
            const response = await API.getProjectPostStats(project.id);

            return {
              ...project,
              stats: response.stats,
            };
          } catch (err) {
            console.log('Error fetching project stats:', err);
            return { ...project, stats: { totalPosts: project.posts?.length } };
          }
        });
        setProjects(projectsWithStats);
      } catch (err) {
        console.log('Error fetching featured projects:', err);
      } finally {
        setLoading(false);
      }
    };

    getProjects();
  }, [currentUser, profileUser]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 my-4">
      {loading
        ? (
          <>
            <Skeleton variant="rectangular" height={250} />
            <Skeleton variant="rectangular" height={250} />
          </>
        )
        : projects.map((project) => (
          <PortfolioCard project={project} key={`portfolio-card-${project.id}`} />
        ))}
    </div>
  );
};
